import React from 'react';
import useMonth from '../hooks/useMonth';
import moment from 'moment';
import 'moment/locale/es';
import CalendarTitle from './CalendarTitle';
import { Container, Row, Col } from 'reactstrap';
moment.locale('es');

const MonthCalendar = ({ goToWeek }) => {
  const { month, slots, nextMonth, prevMonth } = useMonth();

  const get_class = (slot) => {
    if (!slot.date) return 'none-day';
    else if (moment(slot.date, 'DD/MM/YYYY') <= moment()) return 'past';
    else if (!slot.available) return 'non-available';
    else return 'available';
  };

  return (
    <Container>
      <CalendarTitle
        prev={prevMonth}
        title={moment(month.start).format('MMMM')}
        next={nextMonth}
      />
      <Row>
        <Col xs='12' className='d-flex justify-content-between'>
          <table className='table'>
            <thead>
              <tr className='text-center'>
                <th>Lun</th>
                <th>Mar</th>
                <th>Mie</th>
                <th>Jue</th>
                <th>Vie</th>
                <th>Sab</th>
                <th>Dom</th>
              </tr>
            </thead>
            {slots.length > 0 &&
              <tbody>
                {slots.map((week, i) =>
                  <tr>
                    {week.map((slot, j) =>
                      <td
                        key={`${slot.date}-${i}-${j}`}
                        className={`day ${get_class(slot)}`}
                        onClick={() => goToWeek(slot.date)}
                      >
                        {slot.date && moment(slot.date).format('D')}
                      </td>
                    )}
                  </tr>
                )}
              </tbody>
            }
          </table>
        </Col>
      </Row>
    </Container>
  );
};

export default MonthCalendar;